import {
    getIsGuidesEnabled,
    getLittleVeniceSpotlightEnabled,
    getGeoSeoLinksEnabled,
} from './features';

/**
 * Retrieves an object of feature flag values from split.io.
 * Must be called on the server side to use the split.io API Key that is stored in Secrets Manager.
 *
 * NOTE: showZendeskMenu is intentionally hard-disabled here. The homepage SSR
 * response is shared-cached at the CDN (s-maxage) with a cache key that does NOT
 * include the user, so a per-user flag value baked at SSR leaks across users.
 * Per-user Zendesk targeting is being moved to the uncached, per-user consumer-
 * header user BFF + client-side gating; until then the homepage never enables it.
 */
export const getServerSideSplitValues = async () => {
    const splitValues = {
        showGuides: await getIsGuidesEnabled(),
        // `enable_help-center-menu` (browse) is frozen ON: the help-center menu
        // is always enabled. See the flag-collapse PR for the FME definition.
        showHelpCenterMenu: true,
        showZendeskMenu: false,
        littleVeniceSpotlightEnabled: await getLittleVeniceSpotlightEnabled(),
        geoSeoLinksEnabled: await getGeoSeoLinksEnabled(),
    };
    return splitValues;
};

export type SplitValues = Awaited<ReturnType<typeof getServerSideSplitValues>>;
